import { ApplicationState } from '@/features/publicDatasets/types';

export const selectLimitedAccess = (state: ApplicationState) =>
  state.datasource.isLimitedAccess;
